module.exports = __webpack_public_path__ + "img/vacaciones-grecia-thumbnail.347642cf.jpg";